import { render, staticRenderFns } from "./loginIndex.vue?vue&type=template&id=56f5ca4a&scoped=true"
import script from "./loginIndex.vue?vue&type=script&lang=js"
export * from "./loginIndex.vue?vue&type=script&lang=js"
import style0 from "./loginIndex.vue?vue&type=style&index=0&id=56f5ca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5ca4a",
  null
  
)

export default component.exports